import TopicChip from './TopicChip'

export default TopicChip
